import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import { setOrgCode } from 'data/storage';
import { Company } from 'type/company';
import { User } from 'type/user';
// 模型定义, 该用户相关的操作和数据
type InitialState = {
  userInfo: User | null;
  companyList: Company[];
};

const initialState = {
  userInfo: null,
  companyList: [],
  wxUser: null
} as InitialState;

const user = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<User>) {
      state.userInfo = action.payload;
      if (action.payload.orgCode) setOrgCode(action.payload.orgCode);
    },
    setCompanyList(state, action: PayloadAction<Company[]>) {
      state.companyList = action.payload;
    }
  }
});

export default user.reducer;

export const getUserInfo = createAction<string>('user/getUserInfo');
export const getSSOUserInfo = createAction<{ userId: string; companyId: string }>('user/getSSOUserInfo');
export const getCompanyList = createAction('user/getCompanyList');
export const updateMeetingReviewTime = createAction<{ userId: string; meetingId: string }>('user/updateMeetingReviewTime');
export const setReadMeetingRecord = createAction<{ staffId: string; meetingId: string }>('user/setReadMeetingRecord');
export const updateReadMeetingRecord = createAction<{ staffId: string; meetingId: string }>('user/updateReadMeetingRecord');

export const { setUserInfo, setCompanyList } = user.actions;
